
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAfaxnxQv6jukiqCSYriVunRQ3MUS-1-WY",
  authDomain: "am-padel-club-project.firebaseapp.com",
  projectId: "am-padel-club-project",
  storageBucket: "am-padel-club-project.firebasestorage.app",
  messagingSenderId: "412250494691",
  appId: "1:412250494691:web:f6b926819586380b1797d6",
  measurementId: "G-9Y4QZP258J"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
